import { SelectChangeEvent } from "src/components/MuiGenerals";
import { useBatchApproveAllowanceFormContext } from "../../../contexts";
import CurrencySelection from "src/components/ApproveAllowance/CurrencySingleSelection";

function CurrencySingleSelection() {
  const {
    fields,
    setFields,
    translate: t,
  } = useBatchApproveAllowanceFormContext();
  const label = t("currency");

  const onChange = (e: SelectChangeEvent<string>) => {
    setFields((prev) => ({
      ...prev,
      currency: e.target.value,
      spenderAddress: "",
    }));
  };

  return (
    <>
      <div>{label}</div>
      <CurrencySelection
        fieldName={label}
        value={fields.currency}
        onChange={onChange}
        chainName={fields.chainName}
      />
    </>
  );
}

export default CurrencySingleSelection;
